module.exports = __webpack_public_path__ + "img/companyiocnchoose.4c61cf27.svg";